import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class EmpresaAlternaSavoryService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerSegunFiltro(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($codigo_comuna: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            empresa_alterna_savory {
              obtenerSegunFiltro(filtro: { exacto: { codigo_comuna: $codigo_comuna } }, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    idempalt
                    detalle
                    idweb
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.empresa_alterna_savory.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
}
EmpresaAlternaSavoryService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EmpresaAlternaSavoryService_Factory() { return new EmpresaAlternaSavoryService(i0.ɵɵinject(i1.GraphQLClient)); }, token: EmpresaAlternaSavoryService, providedIn: "root" });
